import { render, staticRenderFns } from "./logisticsReminder.vue?vue&type=template&id=25798b75&scoped=true&"
import script from "./logisticsReminder.vue?vue&type=script&lang=js&"
export * from "./logisticsReminder.vue?vue&type=script&lang=js&"
import style0 from "./logisticsReminder.vue?vue&type=style&index=0&id=25798b75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25798b75",
  null
  
)

export default component.exports